import colors from "../../base/colors";
/** Underlined tabs use the existing selection indicator. */
export default {
  styleOverrides: {
    root: {
      position: "relative",
      backgroundColor: "transparent",
      borderRadius: 0,
      minHeight: 44,
      borderBottom: "1px solid " + colors.grey[300],
      padding: 0,
    },
    flexContainer: { height: "100%", position: "relative" },
    indicator: { height: 3, backgroundColor: colors.dark.main, boxShadow: "none" },
    vertical: { "& .MuiTabs-indicator": { width: 3 } },
  },
};
